module.exports = __webpack_public_path__ + "img/catalog-jia.430921ed.svg";